import { render, staticRenderFns } from "./UseHistory.vue?vue&type=template&id=0515f46c&scoped=true&"
import script from "./UseHistory.vue?vue&type=script&lang=js&"
export * from "./UseHistory.vue?vue&type=script&lang=js&"
import style0 from "./UseHistory.vue?vue&type=style&index=0&id=0515f46c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0515f46c",
  null
  
)

export default component.exports